/**
 * @generated SignedSource<<3bbde306c48f1a661782275b01e3af4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JumpToResultSearch_result$data = {
  readonly __typename: "Event";
  readonly guid: string;
  readonly id: string;
  readonly isOneOnOne: boolean;
  readonly nextOccurrence: {
    readonly url: string;
  } | null;
  readonly previousOccurrence: {
    readonly url: string;
  } | null;
  readonly start: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "JumpToResultSearch_result";
} | {
  readonly __typename: "ExternalCompany";
  readonly __typename: "ExternalCompany";
  readonly name: string;
  readonly " $fragmentType": "JumpToResultSearch_result";
} | {
  readonly __typename: "Note";
  readonly eventStart: string | null;
  readonly id: string;
  readonly noteUrl: string | null;
  readonly title: string;
  readonly " $fragmentType": "JumpToResultSearch_result";
} | {
  readonly __typename: "NoteStream";
  readonly displayName: string;
  readonly id: string;
  readonly streamUrl: string | null;
  readonly " $fragmentType": "JumpToResultSearch_result";
} | {
  readonly __typename: "Tag";
  readonly id: string;
  readonly label: string;
  readonly " $fragmentType": "JumpToResultSearch_result";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "JumpToResultSearch_result";
};
export type JumpToResultSearch_result$key = {
  readonly " $data"?: JumpToResultSearch_result$data;
  readonly " $fragmentSpreads": FragmentRefs<"JumpToResultSearch_result">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JumpToResultSearch_result",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": "streamUrl",
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "type": "NoteStream",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOneOnOne",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "nextOccurrence",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "previousOccurrence",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "type": "Tag",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": "noteUrl",
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventStart",
          "storageKey": null
        }
      ],
      "type": "Note",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "ExternalCompany",
      "abstractKey": null
    }
  ],
  "type": "JumpToResult",
  "abstractKey": "__isJumpToResult"
};
})();

(node as any).hash = "a53bb31a27daa7ef2a0d769e93e9d549";

export default node;
